<template>
    <b-container fluid class="d-flex flex-column mh-100 h-100">
        <b-row class="w-100 h-100">
            <b-col cols="2">
                <b-row v-for="subField in this.subClassFieldSet" :key="subField.name">
                    <b-col>
                        <div class="w-75 mx-auto my-2 text-center py-2 bg-gray rounded"
                            :draggable="true"
                            @dragstart="startDrag($event, subField)"
                            @dragover.stop
                            @dragenter.prevent
                            @dragend="endDrag"
                            style="cursor: grab;">
                            {{ subField.name }}
                        </div>
                    </b-col>
                </b-row>
                <b-row v-if="report.ReportParameters.FieldSets.filter(u => !u.equalsFieldSet()).length > 0" v-for="subParam in this.subClassParameter" :key="subParam.name">
                    <b-col>
                        <div class="w-75 mx-auto my-2 text-center py-2 bg-gray rounded"
                            :draggable="true"
                            @dragstart="startDrag($event, subParam)"
                            @dragover.stop
                            @dragenter.prevent
                            @dragend="endDrag"
                            style="cursor: grab;">
                            {{ subParam.name }}
                        </div>
                    </b-col>
                </b-row>
            </b-col>
            <!-- <b-col @dragover="cancelDrop"> -->
            <b-col>
                <b-card v-if="this.report != undefined" class="p-2 w-100 border"
                    body-class="d-flex flex-column align-self-center w-100 p-0 my-0 rounded shadow-sm">
                    <ReportParameter 
                        ref="ReportParameter"
                        :ReportParameters="report.ReportParameters"
                        :FunctionRegistry="functionRegistry"
                        @drop="handleDrop"
                        @dragover="$event.preventDefault()" />
                </b-card>
            </b-col>
        </b-row>

        <b-modal id="modal" size="lg" v-model="openModal" no-close-on-backdrop no-close-on-esc>
        <template #modal-header>
            <div class="h-100 w-100">
                <!-- @Todo: translate-->
                <h5 class="modal-title text-center w-100" style="font-weight: bold;">{{ selectedFunction.Type }}</h5> 
            </div>
        </template>
        <template>
            <ParametersModal :Parameter="selectedFunction"/>
        </template>
        <template #modal-footer>
            <div class="w-100">
                <b-button class="float-right rounded-pill btn-outline-white bg-secondary btnIcon m-1 py-1 px-3" size="sm" variant="secondary" style="height: 2rem;"
                        @click="addObject()">
                    Appliquer
                </b-button>
                <b-button class="float-right rounded-pill btn-outline-secondary bg-white btnIcon m-1 py-1 px-3" size="sm" variant="outline-secondary" style="border-radius: 5px; height: 2rem;" 
                        @click="cancelObject()">
                    Annuler
                </b-button>
            </div>
        </template>
    </b-modal>
    </b-container>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import Report from "@/components/MasterPage/Workbench/RightPane/FeatureContainer/Reporting/Report";
import ReportParameter from "@/components/MasterPage/Workbench/RightPane/FeatureContainer/Reporting/ReportParameter.vue";
import FieldSet from "@/components/MasterPage/Workbench/RightPane/FeatureContainer/Reporting/FieldSet";
import Parameter from "@/components/MasterPage/Workbench/RightPane/FeatureContainer/Reporting/Parameter";
import ParametersModal from "@/components/MasterPage/Workbench/RightPane/FeatureContainer/Reporting/ParametersModal.vue";

@Component({
		components: {
            ReportParameter,
            ParametersModal
		}
	})
export default class DesignerEditor extends Vue {
    @Prop({default: () => "secondary"})
    public Variant!: string;

    private xmlContent: string = 
    `<Root>
        <Parameters>
        </Parameters>
        <FieldSet Title="Période : période de fin" Layout="Column" Type="Client">
            <Parameter Name="FirstYear" Label="Année Début" Type="ComboBox" Data="ConsumptionYears" Value="Previous" />
            <Parameter Name="LastYear" Label="Année Fin" Type="ComboBox" Data="ConsumptionYears" Value="Previous" />
        </FieldSet>
        <FieldSet Title="Période : période du début" Layout="Column" Type="Client">
            <Parameter Name="FirstYear" Label="Année Début" Type="ComboBox" Data="ConsumptionYears" Value="Previous" />
        </FieldSet>
        <FieldSet Title="Correction DJU" Layout="Column" Type="Client">
            <Parameter Name="FirstYear" Label="Année Début" Type="ComboBox" Data="ConsumptionYears" Value="Previous" />
        </FieldSet>
    </Root>`;

    private report: Report = new Report();

    // Récupère toutes les sous-classes de Parameter
    private subClassParameter: typeof Parameter[] = Parameter.getSubclasses();
    // Récupère toutes les sous-classes de FieldSet (Pour l'instant juste la class FieldSet)
    private subClassFieldSet: typeof FieldSet[] = FieldSet.getSubclasses();

    private openModal: boolean = false;
    private functionRegistry: Map<string, Function> = new Map<string, Function>();
    private selectedFunction: any = [];
    
    //#region Drag

    /**
     * 
     * @param evt 
     * @param option Fonction séléctionnée
     */
     private startDrag(evt, option: Function) {
        evt.dataTransfer.dropEffect = 'move';
        evt.dataTransfer.effectAllowed = 'move';
        evt.dataTransfer.setData('targetDrag', option.name);

        // Ajoute la fonction au dictionnaire
        this.functionRegistry.set(option.name, option);

        // Créer des objets temporaire selon le composant séléctionné
        option.prototype.createGhost(this.report);

        // Remet les compteurs à 0 (-1)
        (this.$refs.ReportParameter as ReportParameter).selectedFieldSetIndex = -1;
        (this.$refs.ReportParameter as ReportParameter).selectedParameterIndex = -1;
    }

    /**
     * 
     * @param event 
     * @param target 
     */
    private handleDrop(event, target: string) {
        let targetDrag: Function = this.functionRegistry.get(event.dataTransfer.getData('targetDrag'));
        let targetDragName: string = targetDrag.prototype.getClassName();
        // Si la cible est différente de l'objet demandé
        if(target != targetDragName){
            event.stopPropagation();
        }
        else{
            this.selectedFunction = Reflect.construct(targetDrag, ['']);
            this.openModal = true;
        }

        event.preventDefault();
    };

    /**
     * Action quand la cible n'est pas la bonne
     * @param event 
     */
    private endDrag(event){
        // Si la modal n'est pas ouverte c'est que la cible n'est pas la bonne
        if(!this.openModal){
            let targetDrag: Function = this.functionRegistry.get(event.dataTransfer.getData('targetDrag'));
            targetDrag.prototype.deleteGhost(this.report);
        }
    }

    //#endregion

    // //#region FieldSet

    // // /**
    // //  * Créer des FieldSets Temporaire
    // //  * @param option Function qui contient la class FieldSet
    // //  */
    // // private createTempFieldSet(option: Function){
    // //     // Part de la fin pour ne pas rajouter d'index dans les FieldSets
    // //     for(let x = this.report.FieldSets.length; x > 0; x--){
    // //         // Reflect.construct appel le constructeur
    // //         this.report.FieldSets.splice(x, 0, Reflect.construct(option, ['']))
    // //     }

    // //     // Créer le premier FieldSet temporaire
    // //     this.report.FieldSets.unshift(Reflect.construct(option, ['']))
    // // }

    // /**
    //  * Supprime les FieldSets Temporaire
    //  */
    // // private deleteTempFieldSet(){
    // //     this.report.FieldSets.filter(u => u.equalsFieldSet()).forEach(u => {
    // //         this.report.FieldSets.splice(this.report.FieldSets.indexOf(u), 1);
    // //     })
    // // }

    // /**
    //  * Ouvre la modal avec les propriété de FieldSet
    //  * @param selectedIndex 
    //  */
    //  private openFieldSet(selectedIndex: number) {
    //     // this.modalConstructor = {positionFieldSet: selectedIndex, positionParameter: 0, type: new FieldSet()};
    //     this.openModal = true;
    // }

    // /**
    //  * Ajoute un FieldSet
    //  * @param modalConstructor
    //  */
    //  private addFieldSet(modalConstructor: {positionFieldSet: number, positionParameter: number, type: FieldSet}) {
    //     this.openModal = false;
    //     this.report.FieldSets.splice(modalConstructor.positionFieldSet, 1, modalConstructor.type)
    // }

    // /**
    //  * Supprimer le FieldSet Temporaire
    //  * @param modalConstructor 
    //  */
    //  private closeFieldSet(modalConstructor: {positionFieldSet: number, positionParameter: number, type: FieldSet}){
    //     this.report.FieldSets.splice(modalConstructor.positionFieldSet, 1);
    // }

    // //#endregion

    // //#region Parameter

    // // /**
    // //  * Créer des Parameters Temporaire
    // //  * @param fieldSetIndex 
    // //  */
    // //  private createTempParameter(option: Function, fieldSetIndex: number){
    // //     if(fieldSetIndex != undefined){
    // //         for(let x = this.report.FieldSets[fieldSetIndex].Parameters.length; x > 0; x--){
    // //             this.report.FieldSets[fieldSetIndex].Parameters.splice(x, 0, Reflect.construct(option, ['']))
    // //         }
    // //         this.report.FieldSets[fieldSetIndex].Parameters.unshift(Reflect.construct(option, ['']))
    // //     }
    // // }

    // /**
    //  * Supprime les Parameters Temporaire
    //  * @param fieldSetIndex
    //  */
    //  private deleteTempParameter(){
    //         // Cherche les FieldSet qui a des GhostParameters
    //         let findFieldSets : FieldSet[] = this.report.FieldSets.filter(u => u.Parameters.find(x => x.equalsParameter(new Parameter())));
    //         findFieldSets.forEach(u => {
    //             // Cherche les GhostParameters
    //             u.Parameters.filter(x => x.equalsParameter(new Parameter())).forEach(y => {
    //                 // Supprimer les Ghost Parameters
    //                 u.Parameters.splice(u.Parameters.indexOf(y), 1)
    //             })
    //         })
    // }

    // /**
    //  * Ouvre la modal avec les propriété de Parameter
    //  * @param selectedIndex 
    //  */
    //  private openParameter(selectedFieldSetIndex: number, selectedParameterIndex: number) {
    //     this.openModal = true;
    //     // this.modalConstructor = {positionFieldSet: selectedFieldSetIndex, positionParameter: selectedParameterIndex, type: new Parameter()};
    // }

    // /**
    //  * Ajoute un Parameter
    //  * @param modalConstructor 
    //  */
    //  private addParameter(modalConstructor: {positionFieldSet: number, positionParameter: number, type: Parameter} ) {
    //     this.openModal = false;
    //     this.report.FieldSets[modalConstructor.positionFieldSet].Parameters.splice(modalConstructor.positionParameter, 1, modalConstructor.type)
    // }
    
    // //#endregion

    //#region Object

    private addObject(){
        this.selectedFunction.save(this.report, (this.$refs.ReportParameter as ReportParameter).selectedFieldSetIndex, (this.$refs.ReportParameter as ReportParameter).selectedParameterIndex); 
        this.openModal = false;
    }

    private cancelObject(){
        this.openModal = false
        this.selectedFunction.deleteGhost(this.report);
    }

    private getProperties(){
        if(this.selectedFunction.length != 0){
            return this.selectedFunction.getProperties();
        }
        return '';
    }

    //#endregion

    /**
     * Construit la classe à partir du contenu XML
     */
     private buildClass(){
        // Forced la réactivité et permet de mettre à jour le composant enfant (ReportParameter)
        // this.report = new Report().fromXml(this.xmlContent);
    }

    /**
     * Sauvegarde le contenu XML
     */
    public save() {
        console.log('Saved Report : ', this.report.objectToXml());
    }

    mounted() {
        // console.clear();
        this.buildClass();
    }
}

</script>

<style scoped>
    .editor-container {
    border: 1px solid #ddd;
    border-radius: 5px;
    height: 100%;
    overflow: hidden;
    }

    :deep(input[type=checkbox]:checked) {
        /** Change la couleur de la checkbox */
        accent-color: var(--Variant) !important;
    }

    :deep(input[type=radio]:checked) {
        /** Change la couleur du bouton radio */
        accent-color: var(--Variant) !important;
    }

    /** Pour que la page active prenne en compte la couleur de Variant */
    :deep(.page-item.active .page-link) {
        background-color: var(--Variant) !important;
    }

    :deep(.page-link:hover) {
        background-color: var(--VariantLight) !important;
    }
</style>